import React from 'react';
import { useDelayBadge } from '../services/hubDelay';
import { badgeText } from '../utils/delayBreakdown';

// __DELAY_VIEW__ (2026-10-30) a small badge when a job has billable delay (office logins only; the hub decides). The
// minutes are the hub's billable total -- the same number as the job's Load Details -> Delay tab.
function DelayBadge({ loadId, style }) {
  const min = useDelayBadge(loadId);
  const txt = badgeText(min);
  if (!txt) return null;
  return (
    <span data-delay-badge={min} title={'Billable delay ' + Math.round(min) + ' min (as billing computes it) - open the job, Delay tab, for the breakdown'}
      style={{ display: 'inline-block', padding: '0.05rem 0.4rem', borderRadius: '10px', fontSize: '0.7rem', fontWeight: 'bold',
        whiteSpace: 'nowrap', color: 'var(--bg-primary)', backgroundColor: 'var(--color-warning)', ...(style || {}) }}>
      {txt}
    </span>
  );
}

export default DelayBadge;
